import GoodsDetail from '@/pages/goods/GoodsDetail.vue'
import Cart from '@/pages/goods/Cart'


// 商品相关路由数组
export const goodsRoutes = [
  {
    path: '/goods/:id',
    name: 'GoodsDetail',
    component: GoodsDetail,
    meta: {
      title: '设备详情'
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: {
      title: '购物车',
      requireAuth: true // 需要登录才能访问
    }
  }
]

export default goodsRoutes



// WEBPACK FOOTER //
// ./src/router/goods.js